import { Dispatch } from "redux";
import { INetworkState } from "../../interfaces/network.interface";
import { BLOCKCHAINS, PROVIDERS } from "../../wallets/providers";

export const actionTypes = {
  SET_CHAIN: 'SET_CHAIN',
  SET_PROVIDER: 'SET_PROVIDER',
  SET_WH_CHAIN_ID: 'SET_WH_CHAIN_ID',
  SET_EVM_CHAIN_ID: 'SET_EVM_CHAIN_ID',
  SET_WHOLE_CONFIG: "SET_WHOLE_CONFIG",
  SET_IS_CONNECTED: "SET_IS_CONNECTED",
} as const;

interface SetChainAction {
  type: typeof actionTypes.SET_CHAIN;
  data: BLOCKCHAINS;
}

interface SetProviderAction {
  type: typeof actionTypes.SET_PROVIDER;
  data: PROVIDERS;
}

interface SetWHChainIdAction {
  type: typeof actionTypes.SET_WH_CHAIN_ID;
  data: number;
}

interface SetEVMChainIdAction {
  type: typeof actionTypes.SET_EVM_CHAIN_ID;
  data: number;
}

interface SetNetworkConfigAction {
  type: typeof actionTypes.SET_WHOLE_CONFIG;
  data: INetworkState;
}

interface SetIsConnected {
  type: typeof actionTypes.SET_IS_CONNECTED;
  data: boolean;
}

export type INetworkAction =
  | SetChainAction
  | SetProviderAction
  | SetWHChainIdAction
  | SetEVMChainIdAction
  | SetIsConnected
  | SetNetworkConfigAction;

export const setChain = (data: BLOCKCHAINS) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_CHAIN,
    data,
  });
};

export const setProvider = (data: PROVIDERS) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_PROVIDER,
    data,
  });
};

export const setWHChainId = (data: number) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_WH_CHAIN_ID,
    data,
  });
};

export const setEVMChainId = (data: number) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_EVM_CHAIN_ID,
    data,
  });
};

export const setNetworkConfig = (data: Partial<INetworkState>) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_WHOLE_CONFIG,
    data,
  });
};

export const setIsConnected = (data: boolean) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_IS_CONNECTED,
    data,
  });
};